// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NavGroup } from "./constants";

@Component({
  selector: "nav-card-group",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RSNavCardGroupComponent implements OnInit {
  constructor(public router: Router) {}
  ngOnInit(): void {}

  @Output()
  navClick = new EventEmitter<any>();

  @Input() navList: NavGroup[] = [];
  @Input() customNavClick: boolean = false; // 接收输入属性
  @Input() title = "";

  onNavClick(item) {
    if (!this.customNavClick) {
      this.router.navigate([item.url], { state: { title: item.title } });
    }
    this.navClick.emit(item);
  }
}
